module.exports = __webpack_public_path__ + "static/media/linkedin-hcr-grey.288e52d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/linkedin-hcr-grey.svg
// module id = 1484
// module chunks = 0